import { SubLayout } from '@/components/layouts'
const routes = {
  path: '/supplier',
  redirect: '/supplier/supplierList',
  component: SubLayout,
  children: [
    {
      path: 'supplierList',
      name: 'supplierList',
      meta: {
        title: '供应商管理'
      },
      component: () => import('@/views/supplier/SupplierList')
    },
    {
      path: 'supplierList/purchaseRecord/:supplierId',
      name: 'purchaseRecordList',
      meta: {
        title: '供应商采购记录'
      },
      component: () => import('@/views/supplier/PurchaseRecordList')
    },
    {
      path: 'supplierList/purchaseDetail/:supplierId',
      name: 'purchaseDetail',
      meta: {
        title: '采购填报'
      },
      component: () => import('@/views/supplier/PurchaseDetail')
    }
  ]
}

export default routes
